export default __webpack_public_path__ + "static/graphik-web-regular-0c0bbaef63165949ccefd6e648184b16.woff2";